module.exports = __webpack_public_path__ + "img/by.d08efa04.svg";